import {CityPin} from "./CityPin";

const mapImport = import.meta.glob('./config/map.json')

export class ClassesMap extends HTMLElement {
  async connectedCallback() {
    this.innerHTML = `
      <div>
        <img class="map-svg" src="./map/v7.svg" alt="Карта">
        <div class="pins"></div>
        <map-card class="map-card" show="false"/>
      </div>
    `

    this.selectedPin = null
    const map = await mapImport['./config/map.json']()

    this.mapCard = this.querySelector('map-card')

    this.mapData = map.default
    this.mapImg = this.querySelector('img.map-svg')

    await new Promise(resolve => {
      if (this.mapImg.complete) return resolve()
      this.mapImg.onload = resolve
    })

    this.placeMap = Object.groupBy(this.mapData.universities, u => u.city)

    this.addEventListener('click', (ev) => {
      if (ev.target === this.mapImg) {
        this.selectedPin?.removeAttribute('active')
        this.mapCard.removeAttribute('active')
      }
    })

    this.render()
    addEventListener("resize", this.render.bind(this));
  }

  render() {
    this.mapH = this.mapImg.clientHeight
    this.mapW = this.mapImg.clientWidth
    this.pins = this.querySelector('div.pins')
    this.pins.innerHTML = ''

    for (const place of this.mapData.places) {
      const pin = new CityPin()
      pin.classList.add('city-pin')

      pin.setAttribute('name', place.name)
      pin.setAttribute('posy', place.location.y * this.mapH)
      pin.setAttribute('posx', place.location.x * this.mapW)
      if (place.alwaysShow)
        pin.setAttribute('always-show', '')
      if (place.classes)
        pin.classList.add(...place.classes)

      pin.addEventListener('click', (ev) => {
        ev.stopPropagation()
        this.selectedPin?.removeAttribute('active')
        this.selectedPin = pin
        this.selectedPin.setAttribute('active', '')

        this.mapCard.removeAttribute('active')
        this.mapCard.removeAttribute('place')
        this.mapCard.removeAttribute('universities')

        if (place && this.placeMap[place.name]) {
          this.mapCard.setAttribute('place', JSON.stringify(place))
          this.mapCard.setAttribute('universities', JSON.stringify(this.placeMap[place.name]))
          this.mapCard.setAttribute('active', '')
        }
      })

      this.pins.appendChild(pin)
    }
  }
}